import { render } from "./RequestFormCourse.vue?vue&type=template&id=2d8017a2&ts=true&lang=pug"
import script from "./RequestFormCourse.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestFormCourse.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__